import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/404";
import AboutUs from "./pages/AboutUs";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ContactUs from "./pages/Contact-us";
import Connections from "./pages/Connections";
import Legal from "./pages/legal/Legal";
import Privacy from "./pages/privacy/Privacy";
import AdminDashboard from "./components/AdminDashboard";
import Apply from "./components/Apply";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ProtectedRoute from "./components/ProtectedRoute";
import EmailSender from "./components/EmailSender";
import UnderConstruction from "./components/UnderConstruction";
import Users from "./pages/Users";

function App() {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.Weglot?.checkForNewContent) {
        window.Weglot.checkForNewContent();
      }
      const lang = window.Weglot?.getCurrentLang?.();

      if (lang === "ar") {
        document.documentElement.setAttribute("dir", "rtl");
      } else {
        document.documentElement.setAttribute("dir", "ltr");
      }
    }, 200); // Delay slightly to wait for DOM update

    return () => clearTimeout(timer); // cleanup on unmount
  }, [location]);
  return (
    <>
      <Navbar />
      <Routes>
        {/* <Route path="/" element={<UnderConstruction />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/our-network" element={<Connections />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/send-email" element={<EmailSender />} />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />

      <ToastContainer />
    </>
  );
}

export default App;
